// Epoch 26: Authenticated Route with Global Trial Banner
// This component wraps ProfileCompletionGuard and adds AuthenticatedLayout
// Date: August 7, 2025

import React from 'react';
import ProfileCompletionGuard from './ProfileCompletionGuard';
import AuthenticatedLayout from '../layouts/AuthenticatedLayout';

interface AuthenticatedRouteProps {
  children: React.ReactNode;
  showHeader?: boolean;
  showTrialBanner?: boolean;
}

const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({ 
  children, 
  showHeader = true,
  showTrialBanner = true 
}) => {
  return (
    <ProfileCompletionGuard>
      <AuthenticatedLayout showHeader={showHeader} showTrialBanner={showTrialBanner}>
        {children}
      </AuthenticatedLayout>
    </ProfileCompletionGuard>
  );
};

export default AuthenticatedRoute;